import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterCrudIndexComponent } from './filter-crud-index.component';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [FilterCrudIndexComponent],
  imports: [
    CommonModule,
    FieldsModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    FlexLayoutModule
  ],
  exports: [FilterCrudIndexComponent]
})
export class FilterCrudIndexModule { }
